//@ts-nocheck
import EmbedTab from './EmbedTab';
import DeleteModal from '../DeleteModal/DeleteModal';
import GeneratePdfOptions from './TripDownloadPdf';
import ShareTab from './ShareTab';
import { Box, Modal } from '@mui/material';
import {
  ShareNetwork,
  Trash,
  ListMagnifyingGlass
} from '@phosphor-icons/react';
import { useState } from 'react';
import { XGButton, XGTabs } from '@xg-cl/xg-cl';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ErrorToast } from '../../../utils/alerts';
import { deleteTrip } from '../../../services/trip/trip';
import * as PropTypes from 'prop-types';
import './TripHeaderActions.css';

const TripHeaderActions = ({ id }) => {
  const trip = useSelector((state) => state.trip);
  const navigate = useNavigate();
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { t } = useTranslation(['trip', 'common', 'embed']);
  const { tripid, ispublic } = trip;
  const [isPublic, setIsPublic] = useState(ispublic);

  const toggleShareDialog = () => {
    setOpenShareDialog(!openShareDialog);
    localStorage.removeItem('customColor');
    localStorage.removeItem('customText');
  };

  const modalTabs = [
    {
      title: 'Share',
      content: (
        <ShareTab
          tripid={tripid}
          isPublic={isPublic}
          setIsPublic={setIsPublic}
        />
      )
    },
    { title: 'Embed', content: <EmbedTab tripid={tripid} /> }
  ];

  const openTab = () => {
    window.open(`/itineraries/${tripid}`, '_blank');
  };

  const handleDeleteTripClick = async () => {
    setIsDeleteModalOpen(true);
  };

  const handleOnConfirmRemoval = async () => {
    try {
      setIsDeleting(true);
      await deleteTrip(tripid);
      navigate('/trips');
    } catch (error) {
      ErrorToast(t('errors:tripCouldNotBeDeleted', { reason: error.message }));
    } finally {
      setIsDeleting(false);
    }
  };

  const handleOnCancelRemoval = () => {
    setIsDeleteModalOpen(false);
  };

  return (
    <div
      className='trip-header-actions'
      id={id}
      data-testid='trip-header-actions-component'
    >
      <GeneratePdfOptions tripId={tripid} />

      <XGButton
        startIcon={<Trash width={23} />}
        data-testid='itinerary-delete-button'
        id='itinerary-delete-button'
        text={t('common:delete')}
        type='secondary'
        size='large'
        variant='outlined'
        onClick={handleDeleteTripClick}
        style={{
          padding: '8px 14px'
        }}
      />

      <XGButton
        startIcon={<ShareNetwork width={17} />}
        data-testid='trip-header-actions-share-button'
        id='itinerary-preview-button'
        text={t('common:share')}
        type='secondary'
        size='large'
        variant='outlined'
        onClick={toggleShareDialog}
      />

      <XGButton
        startIcon={<ListMagnifyingGlass width={23} color='#fff' />}
        data-testid='itinerary-preview-button'
        id='itinerary-preview-button'
        text={t('common:preview')}
        type='primary'
        size='large'
        variant='contained'
        onClick={openTab}
      />

      <Modal
        open={openShareDialog}
        onClose={toggleShareDialog}
        data-testid='trip-header-actions-modal'
      >
        <Box className='trip-modal-box'>
          <XGTabs id='modal-tabs' tabs={modalTabs} />
          <div className='share-dialog-close-button'>
            <XGButton
              data-testid='share-dialog-close-button'
              id='dialog-close-button'
              text={t('common:close')}
              type='secondary'
              size='large'
              variant='outlined'
              onClick={toggleShareDialog}
            ></XGButton>
          </div>
        </Box>
      </Modal>

      <DeleteModal
        id='delete-amenity-modal'
        isOpenModal={isDeleteModalOpen}
        title={t('trip:deleteTrip')}
        onConfirm={handleOnConfirmRemoval}
        onCancel={handleOnCancelRemoval}
        description={`${t('trip:deleteTripConfirmation')} ${t(
          'common:thisActionCannotBeUndone'
        )}`}
        isSubmitting={isDeleting}
      />
    </div>
  );
};

TripHeaderActions.propTypes = {
  id: PropTypes.string
};

export default TripHeaderActions;
